export const genRandomPercent = (min, max) => {  
  var rand = Math.random() < 0.5 ? ((1-Math.random()) * (max-min) + min) : (Math.random() * (max-min) + min);  // could be min or max or anything in between
  var power = Math.pow(10, 2);
  return Math.floor(rand*power) / power;
}